import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GallryPageComponent } from './gallry-page/gallry-page.component';

const routes: Routes = [
  {
    path: '',
    component: GallryPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GalleryPageRoutingModule { }
